import {
    type BrowserVoiceDeviceConstructor,
    type LoadBrowserVoiceDeviceConstructor,
} from '@apps/web/lib/browser_voice_device_adapter_contract';

// Keep the production SDK import lazy so pages that do not use browser calling
// do not load it.
export const loadBrowserVoiceDeviceConstructor: LoadBrowserVoiceDeviceConstructor =
    async () => {
        const { Device } = await import('@twilio/voice-sdk');
        return Device as unknown as BrowserVoiceDeviceConstructor;
    };
